<template>
  <section id="cookieAcceptPopup" class="cookie-accept-popup">
    <div class="content">
        <div class="cookie-accept-popup-container">
            <p v-text="translations[lang].text"/>
            <button
              class="custom-button"
              id="cookieAcceptButton"
              type="submit"
              v-text="translations[lang].button"
              @click="cookieAccept"/>
        </div>
    </div>
  </section>
</template>

<script>
import { localeStore } from '@/locale';

export default {
  props: {
    close: {
      default: () => null,
      type: Function,
    },
  },
  setup(props) {
    const cookieAccept = () => {
      localStorage.setItem('show', false);
      props.close();
    };
    return {
      cookieAccept,
    };
  },
  data: () => ({
    lang: localeStore.lang,
    translations: {
      en: {
        button: 'Accept',
        text: 'Cookies help us provide you with a better website, by enabling us to collect your experience we will improve our product and services for you.',
      },
      ru: {
        button: 'Принять',
        text: 'Этот сайт использует файлы cookies, которые помогают нам улучшить качество веб-сайта',
      },
    },
  }),
};
</script>
